import React, { Component } from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Button, Icon, message, Tree, Input } from 'antd';
import API_URL from '../../common/url';

const TreeNode = Tree.TreeNode;

class CasCadeOption extends Component {
    state = {
        options : [],
        expandedKeys: [],
        visible: false,
    };

    show = (moduleDefineCode) => {
        this.setState({
            visible: true,
            moduleDefineCode,
            showCascader: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            showCascader: false,
            expandedKeys: [],
        });
    };

    loadData = (againstTypeId) => {
        const { expandedKeys } = this.state;
        const { moduleDefineCode } = this.state;
        const options = {
            url: `${API_URL.executeMgr.listAgainstType}`,
            data: {
                moduleDefineCode,
                type: 'patient',
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    if (expandedKeys.length == 0 ) {
                        if (res.data && (res.data.length > 0)) {
                            res.data.map(item => {
                                if (item.deepValue == 1) {
                                    expandedKeys.push(item.againstTypeId + '');
                                }
                            })
                        }
                    }
                    this.setState({
                        dataList: res.data,
                        expandedKeys: [...expandedKeys, againstTypeId],
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    deleteConfirm = (againstTypeId, againstTypeName) => {
        const _this = this;
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: `确定要删除选项“${againstTypeName}”吗?`,
            onOk() {
                _this.deleteCascade(againstTypeId);
            },
            onCancel() {
            },
        });
    }

    deleteCascade = (againstTypeId) => {
        const { moduleDefineCode } = this.state;
        const options = {
            url: `${API_URL.executeMgr.deleteAgainstType}`,
            data: {
                againstTypeId,
                moduleDefineCode
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            }),
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = this.loopMap(dataList);
        }
        return data;
    }

    onExpand = (expandedKeys, node) => {
        this.setState({ expandedKeys });
    }

    showSetOption = params => {
        this.SetOptionRef.show(params);
    }

    loopMap = data => {
        return data.map(item => {
            if (item.children && (item.children.length > 0)) {
                if (item.deepValue == 2) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.againstTypeName}
                                <Icon onClick={() => this.showSetOption({type: 'add', againstTypeParentId: item.againstTypeId, againstTypeName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                            </div>}
                            key={item.againstTypeId + ''}
                        >
                            { this.loopMap(item.children) }
                        </TreeNode>
                    )
                } else if (item.deepValue > 2) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.againstTypeName}
                                <Icon onClick={() => this.showSetOption({type: 'add', againstTypeParentId: item.againstTypeId, againstTypeName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                <Icon onClick={() => this.showSetOption({type: 'edit', againstTypeId: item.againstTypeId, againstTypeName: item.againstTypeName})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                <Icon onClick={() => this.deleteConfirm(item.againstTypeId, item.againstTypeName)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                            </div>}
                            key={item.againstTypeId + ''}
                        >
                            { this.loopMap(item.children) }
                        </TreeNode>
                    )
                } else {
                    return (
                        <TreeNode title={item.againstTypeName} key={item.againstTypeId + ''}>
                        { this.loopMap(item.children) }
                        </TreeNode>
                    )
                }
            } else {
                if (item.deepValue == 2) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.againstTypeName}
                                <Icon onClick={() => this.showSetOption({type: 'add', againstTypeParentId: item.againstTypeId, againstTypeName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                            </div>}
                            key={item.againstTypeId + ''}
                        />
                    )
                } else if ((item.deepValue > 2) && (item.deepValue < 6)) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.againstTypeName}
                                <Icon onClick={() => this.showSetOption({type: 'add', againstTypeParentId: item.againstTypeId, againstTypeName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                <Icon onClick={() => this.showSetOption({type: 'edit', againstTypeId: item.againstTypeId, againstTypeName: item.againstTypeName})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                <Icon onClick={() => this.deleteConfirm(item.againstTypeId, item.againstTypeName)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                            </div>}
                            key={item.againstTypeId + ''}
                        />
                    )
                } else if (item.deepValue >= 6) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.againstTypeName}
                                <Icon onClick={() => this.showSetOption({type: 'edit', againstTypeId: item.againstTypeId, againstTypeName: item.againstTypeName})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                <Icon onClick={() => this.deleteConfirm(item.againstTypeId, item.againstTypeName)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                            </div>}
                            key={item.againstTypeId + ''}
                        />
                    )
                } else {
                    return <TreeNode title={item.againstTypeName} key={item.againstTypeId + ''} />
                }
            }
        })
    }

    render() {
        const { visible, expandedKeys } = this.state;
        return (
            visible &&
            <Modal
                title="设置可选项"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div className="modal-content">
                        <ul className="modal-list">
                            <li className="modal-item" style={{paddingBottom: 20}}>
                                <Tree
                                    showLine
                                    onExpand={this.onExpand}
                                    expandedKeys={expandedKeys}
                                >
                                    { this.getDataList() }
                                </Tree>
                            </li>
                        </ul>
                    </div>
                    <SetOption ref={el => this.SetOptionRef = el}  reLoad={this.loadData} />
                </div>
            </Modal>
        );
    }
}

class SetOption extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    };

    show = params => {
        this.setState({
            params,
            visible: true
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    confirm = () => {
        const { params } = this.state;
        const { type, againstTypeName = '' } = params;
        if (againstTypeName.trim() == '') {
            message.warning('请输入选项名称');
            return;
        }
        const  url = type == 'add' ? API_URL.executeMgr.addAgainstType : API_URL.executeMgr.modifyAgainstType;

        this.setState({ confirmLoading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                typeValue: 'patient'
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({
                        visible: false,
                        confirmLoading: false
                    }, () => {
                        this.props.reLoad(res.againstId + '');
                    });
                } else {
                    message.error(res.error);
                    this.setState({ confirmLoading: false });
                }
            }),
            errorResult: (() => {
                this.setState({ confirmLoading: false });
            })
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render() {
        const { visible, confirmLoading, params = {} } = this.state;
        const { againstTypeName = '', type = '' } = params;
        return (
            <Modal
                title={ type == 'add'? '添加选项' : '修改选项'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>选项名称:</div>
                            <div className="item-right">
                                <Input
                                    maxLength='30'
                                    value={againstTypeName}
                                    placeholder="请输入选项名称"
                                    onChange={e => this.handleInputChange(e, 'againstTypeName')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

class SelectOption extends Component {
    state = {
        visible: false,
        optionValue: '',
    };

    show = (record) => {
        this.setState({
            visible: true,
            moduleDefineId: record.moduleDefineId,
            moduleDefineCode: record.moduleDefineCode,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
        }, () => {
            this.props.loadData();
        });
    };

    loadData = () => {
        const { moduleDefineId } = this.state;
        const options = {
            url: `${API_URL.execute.getCategoryTree}`,
            data: {
                typeName: 'Type_Nopatient_Violation',
                isDefine: 1,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    let dataList = [];
                    res.data.tableColumns.map(item => {
                        if (item.moduleDefineId == moduleDefineId) {
                            dataList = item.moduleDefineConstraintValue.split('//');
                        }
                    });
                    this.setState({ dataList });
                }
            }),
        };
        $.sendRequest(options);
    }

    saveData = (params) => {
        const { moduleDefineId, moduleDefineCode } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.execute.updateExecuteDefineOption,
            data: {
                moduleDefineCode,
                moduleDefineId,
                ...params,
                typeName: 'Type_Nopatient_Violation',
            },
            dataType: 'json',
            doneResult: () => {
                message.success('编辑成功');
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    handleInputChange = e => {
        this.setState({ optionValue: e.target.value });
    }

    handleAddBtn = () => {
        const { optionValue, dataList, moduleDefineId } = this.state;
        if (optionValue.trim() == '') {
            message.warning('请输入可选项');
            return;
        }

        let params = {};
        dataList.forEach((item, index) => {
            params[`arrays[${index}]`] = item;
        });
        params[`arrays[${dataList.length}]`] = optionValue;

        this.saveData(params);
    }

    handleRemoveItem = (e, i) => {
        const { dataList } = this.state;
        const list = [...dataList];
        list.splice(i, 1);

        let params = {};
        list.map((item, index) => {
            params[`arrays[${index}]`] = item;
        })
        this.saveData(params);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = dataList.map((item, index) => 
                <div key={index}>
                    <div style={{position: 'relative', marginBottom: 4, paddingLeft: 10, paddingRight: 20, background: '#f1f1f1'}}>
                        <div title={item} style={{overflow: 'hidden', wordSpace: 'no-wrap', textOverflow: 'ellipsis'}}>{item}</div>
                        {
                            (item != '项目重要文件丢失' && item != '数据涉嫌造假') &&
                            <Icon style={{position: 'absolute', top: 5, right: 5, color: 'red', cursor: 'pointer'}}type="close-circle-o" onClick={e => this.handleRemoveItem(e, index)}/>
                        }
                    </div>
                </div>   
            )
        }
        return data;
    }

    render() {
        const { visible, optionValue } = this.state;
        return (
            <Modal
                title="设置可选项"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="440px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20, borderBottom: '1px solid #dcdcdc'}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}><span style={{color: 'red'}}>*</span>可选项:</div>
                            <div className="item-right" style={{width: 190}}>
                                <Input placeholder='请输入' value={optionValue} onChange={this.handleInputChange}/>
                            </div>
                            <Button type="primary" style={{marginLeft: 20}} onClick={this.handleAddBtn}>添加</Button>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>已添加可选项:</div>
                            <div className="item-right" style={{width: '73%'}}>
                            { this.getDataList() }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export { CasCadeOption, SelectOption };


// WEBPACK FOOTER //
// ./src/components/executeMgr/ViolationModal.js